import React from 'react'

import './PrintPageWrapper.css'
import { View } from 'lib/components'

export default function PrintPageWrapper(props: any) {
  return <View id="print-page">{props.children}</View>
}
